import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';

import JeepytaCheckbox from './components/JeepytaCheckbox';
import JeepytaHistoryCheckbox from './components/JeepytaHistoryCheckbox';

import SettingsPage from 'flarum/forum/components/SettingsPage';

app.initializers.add('vendor/jeepyta-options', () => {

  extend(SettingsPage.prototype, 'settingsItems', function(items) {
    // console.log('[vendor/jeepyta-options] Hello, forum!');
    items.add('jeepyta-checkbox',
      JeepytaCheckbox.component({user: this.user})
    );

    // items.add('jeepyta-history-checkbox',
    //   JeepytaHistoryCheckbox.component({user: this.user})
    // );
  });

});
